// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QiuB","comment":"styles_comment__3eReV"};